import { useEffect, FC } from 'react';
import { useForm } from 'react-hook-form';

import {
  initContractFormFields,
  type ContractFormFields,
} from 'page/CustomerPage/types/contractFormField';
import {
  useContractEditStore,
  useContractListStore,
} from 'page/CustomerPage/hooks';
import { InputModal } from './InputModal';
import { ConfirmationModal } from './ConfirmationModal';
import { DeleteModal } from './DeleteModal';

export const ContractEditModal: FC = () => {
  const { clearSelectedContract } = useContractListStore();
  const {
    menuId,
    valid,
    init: initEdit,
    goInputModal,
    goConfirmationModal,
    goDeleteModal,
    setForm,
    putContractAndReload,
    deleteContractAndReload,
  } = useContractEditStore();

  const { formState, register, getValues, reset } = useForm<ContractFormFields>(
    {
      defaultValues: initContractFormFields,
      mode: 'all',
    },
  );

  useEffect(() => {
    reset({
      menuId: menuId ? menuId.toString() : '',
      valid,
    });
  }, [menuId, valid, reset]);

  /**
   * モーダルを閉じたときにおこなう一連の初期化処理
   */
  const initState = () => {
    // フォームをリセット
    reset();
    // 編集画面の state を初期化
    initEdit();
    // 選択された契約のリセット
    clearSelectedContract();
  };

  /**
   * 入力モーダル・確認モーダル・削除モーダルで右上の「×」ボタンをクリックしたときの処理
   */
  const handleClose = () => {
    // 初期化
    initState();
  };

  /**
   * 入力モーダルで「確認」ボタンをクリックしたときの処理
   */
  const handleClickGoConfirmation = () => {
    // フォームの内容を state に保存
    setForm(getValues());
    // 確認モーダルに進む
    goConfirmationModal();
  };

  /**
   * 入力モーダルで「削除」ボタンをクリックしたときの処理
   */
  const handleClickGoDelete = () => {
    // フォームの内容を state に保存
    setForm(getValues());
    // 削除モーダルに進む
    goDeleteModal();
  };

  /**
   * 確認モーダルで「入力画面に戻る」ボタンをクリックしたときの処理
   */
  const handleClickGoInput = () => {
    // 入力モーダルに戻る
    goInputModal();
  };

  /**
   * 確認モーダルで「更新ボタン」をクリックしたときの処理
   */
  const handleClickUpdate = () => {
    // 契約編集処理＆一覧をリロード
    void putContractAndReload();
    // 初期化
    initState();
  };

  /**
   * 削除モーダルで「削除ボタン」をクリックしたときの処理
   */
  const handleClickDelete = () => {
    // 契約削除処理＆一覧をリロード
    void deleteContractAndReload();
    // 初期化
    initState();
  };

  return (
    <>
      {/* 入力モーダルコンテナ */}
      <InputModal
        formState={formState}
        register={register}
        handleClose={handleClose}
        handleClickGoConfirmation={handleClickGoConfirmation}
        handleClickGoDelete={handleClickGoDelete}
      />
      {/* 確認モーダルコンテナ */}
      <ConfirmationModal
        handleClose={handleClose}
        handleClickGoInput={handleClickGoInput}
        handleClickUpdate={handleClickUpdate}
      />
      {/* 削除モーダルコンテナ */}
      <DeleteModal
        handleClose={handleClose}
        handleClickGoInput={handleClickGoInput}
        handleClickDelete={handleClickDelete}
      />
    </>
  );
};
